import { forwardRef } from 'react';
import { Link } from '../navigation/link.jsx';

function getButtonClasses(variant, size, className) {
	const isIcon = size === 'icon';
	return [
		!isIcon ? 'btn' : '',
		!isIcon && variant === 'primary' ? 'btn-primary' : '',
		!isIcon && variant === 'danger' ? 'btn-danger' : '',
		!isIcon && variant === 'ghost' ? 'btn-ghost' : '',
		!isIcon && size === 'sm' ? 'btn-sm' : '',

		isIcon ? 'btn-icon' : '',
		className,
	].filter(Boolean).join(' ');
}

/**
 * @param {Object} props
 * @param {'primary'|'secondary'|'danger'|'ghost'} [props.variant='secondary']
 * @param {'sm'|'md'|'icon'} [props.size='md']
 * @param {'button'|'link'} [props.as='button']
 * @param {string} [props.to]
 * @param {boolean} [props.loading]
 * @param {import('react').ReactNode} [props.icon]
 * @param {string} [props.className]
 * @param {import('react').ReactNode} [props.children]
 * @returns {JSX.Element}
 */
export const Button = forwardRef(function Button(
	{ variant = 'secondary', size = 'md', as: asProp = 'button', to, loading, icon, className = '', children, ...rest },
	ref,
) {
	const classes = getButtonClasses(variant, size, className);

	if (size === 'icon') {
		return (
			<button
				ref={ref}
				{...rest}
				className={classes}
				type={rest.type || 'button'}
				onClick={(e) => { e.stopPropagation(); rest.onClick?.(e); }}
			>
				{icon}
			</button>
		);
	}

	if (asProp === 'link' && to) {
		const linkRest = (({ disabled: _disabled, type: _type, ...o }) => o)(rest);
		return (
			<Link to={to} className={classes} {...linkRest}>
				{icon && <span className="btn-icon-left">{icon}</span>}
				{children}
			</Link>
		);
	}

	return (
		<button
			ref={ref}
			{...rest}
			className={classes}
			type={rest.type || 'button'}
			disabled={loading || rest.disabled}
			onClick={(e) => { e.stopPropagation(); rest.onClick?.(e); }}
		>
			{loading && <span className="spinner spinner-sm" />}
			{icon && !loading && <span className="btn-icon-left">{icon}</span>}
			{children}
		</button>
	);
});
